import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";

/**
 * If the app is loaded from the private admin subdomain (e.g. admin.hermesmobility.com)
 * redirect the root path to /admin/ops so operators land straight on the ops panel.
 * Also blocks common public routes on that hostname — treat the admin subdomain as
 * an ops-only surface.
 */
const ADMIN_HOST_PREFIX = "admin.";
const PUBLIC_PATHS_ON_ADMIN_HOST = new Set(["/", "/about", "/schedule", "/register"]);

export default function AdminSubdomainRedirect() {
  const loc = useLocation();
  const nav = useNavigate();

  useEffect(() => {
    if (typeof window === "undefined") return;
    const host = window.location.hostname || "";
    const isAdminHost = host.startsWith(ADMIN_HOST_PREFIX);
    if (!isAdminHost) return;

    // Admin host → if on a public landing path, redirect into ops.
    if (PUBLIC_PATHS_ON_ADMIN_HOST.has(loc.pathname)) {
      nav("/admin/ops", { replace: true });
    }
  }, [loc.pathname, nav]);

  return null;
}
